import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import MapView from '@arcgis/core/views/MapView';
import { MapService } from '../../services/map.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BasemapGalleryWidgetComponent } from './basemap-gallery-widget/basemap-gallery-widget.component';

@Component({
  selector: 'app-basemap-gallery-widget-visualization',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatCardModule, TranslocoPipe, BasemapGalleryWidgetComponent],
  templateUrl: './basemap-gallery-widget-visualization.component.html',
  styleUrls: ['./basemap-gallery-widget-visualization.component.scss']
})
export class BasemapGalleryWidgetVisualizationComponent {

  @Input({required: true}) mapview!: MapView;
  
  public mapService = inject(MapService);
  public show = this.mapService.showBaseMapGallery;

  public toggleShow() {
    this.mapService.toggleShowBaseMapGallery();
  }
  

}
